module.exports = __webpack_public_path__ + "img/2018-12-21.30f92f65.jpg";